import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useHistory } from "react-router-dom";

import SuspiciousActivityAction from "@common/redux/actions/SuspiciousActivityAction";
import { suspiciousActivitySchema } from "@common/components/helpers/validation-schemas/suspiciousActivitySchema";
import { useEffect } from "react";
import { fetchPoliceId } from "../helpers/Officer/searchOfficer";
import LoginAction from "@common/redux/actions/LoginAction";
import { fetchSuspiciousActivityMetaData } from "../helpers/SuspiciousActivity/fetchSuspiciousActivityData";
import useCompliance from "./useCompliance";

const useSuspiciousActivity = () => {
  const history = useHistory();
  const { optionDisplaySessionsInCompliance } = useSelector((state) =>
    LoginAction.getStatePath(state),
  );
  const data = useSelector((state) =>
    SuspiciousActivityAction.getStatePath(state),
  );

  const schema = suspiciousActivitySchema(false);

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: data.formData,
    mode: "all",
  });

  const { resetComplianceForms } = useCompliance(methods);

  const handleBack = () => resetComplianceForms();
  const handleClose = () => {
    resetComplianceForms();
    history.push("/compliance/alerts");
  };

  useEffect(() => fetchPoliceId(), []);

  useEffect(() => fetchSuspiciousActivityMetaData(), []);

  return { ...data, methods, handleBack, handleClose };
};

export default useSuspiciousActivity;
